import IntlMessages from 'helpers/IntlMessages';
import { getDiscourseActivationUrl } from 'services/discourseActivation';

export const ActivateDiscourseChatButton = ({ className = '' }: { className?: string }) => {
  const activationUrl = getDiscourseActivationUrl();

  if (!activationUrl) {
    return null;
  }

  return (
    <a
      className={`btn btn-primary ${className}`.trim()}
      href={activationUrl}
      data-testid="activate-discourse-chat"
    >
      <IntlMessages id="onboarding.activate-chat" defaultMessage="Activate chat" />
    </a>
  );
};

const ActivateDiscourseChat = ({ onLater }: { onLater: () => void }) => (
  <div className="d-flex flex-column align-items-center text-center px-2 py-4">
    <h2 className="font-weight-bolder mb-3">
      <IntlMessages id="onboarding.chat-title" defaultMessage="Connect with the ARK community" />
    </h2>
    <p className="h5 text-normal mb-4">
      <IntlMessages
        id="onboarding.chat-description"
        defaultMessage="Open ARK Chat once to activate chat so other members can start conversations with you."
      />
    </p>
    <div className="d-flex flex-wrap justify-content-center">
      <button type="button" className="btn btn-outline-primary mx-2 mb-2" onClick={onLater}>
        <IntlMessages id="onboarding.later" />
      </button>
      <ActivateDiscourseChatButton className="mx-2 mb-2" />
    </div>
  </div>
);

export default ActivateDiscourseChat;
